module.exports = "  <div *ngIf=\"detectUrl()\">\n    <my-navigation-layout></my-navigation-layout>\n  </div>\n  <my-home *ngIf=\"!authService.loggedin && authService.appLoader\"></my-home>\n  <router-outlet></router-outlet>\n  <button *ngIf=\"showHide\" (click)=\"scrollToTop(500)\" ngClass=\"scrollTop\"> <span><i class=\"fa fa-chevron-up\" aria-hidden=\"true\"></i></span></button>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 920
// module chunks = 9